import React from "react";
import { useParams } from "react-router-dom";
import LoopModal from "@/layout/components/helpers/LoopModal";
import Translator from "@/layout/components/helpers/Translator";
import ReactDOMServer from "react-dom/server";
import { AppNotificationAlert } from "@/layout/AppComponents";
import GenerateReport from "./GenerateReport";
import { useSelector } from "react-redux";

const ModalsGenerateReport = (props) => {
  const { startGenerateReport, setStartGenerateReport, setOnlineInfo } = props;
  const { moduleBridgeHex } = useParams();
  const newReports = useSelector((state) => state.currentPage?.newReports);

  const onFinishNew = (response) => {
    setStartGenerateReport(null);
    if (typeof response === "string") window.open(response, "_self");
    else {
      if (response.reportUrl) window.open(response.reportUrl, "_self");
      setOnlineInfo(response);
    }
  };

  const onFinishOld = (response) => {
    setStartGenerateReport(null);
    if (typeof response === "string") window.open(response, "_self");
    else {
      if (response.reportUrl) window.open(response.reportUrl, "_self");
      setOnlineInfo(response);
    }
  };

  const onError = () => {
    setStartGenerateReport(false);
    AppNotificationAlert({
      title: ReactDOMServer.renderToString(
        <Translator file="user" name="user.error" />,
      ),
      message: ReactDOMServer.renderToString(
        <Translator
          file="module-intelligence"
          name="error.report.not.created"
        />,
      ),
      type: "danger",
      position: "top-center",
      duration: 0,
    });
  };

  return (
    <>
      {startGenerateReport && (
        <>
          {newReports.includes(startGenerateReport?.report?.type?.id) ? (
            <LoopModal
              route="api_r_user_m_intelligence_calculateReport"
              value={{
                values: startGenerateReport,
                moduleBridgeHex,
              }}
              onFinish={onFinishNew}
              onError={onError}
            />
          ) : (
            <GenerateReport
              moduleBridgeHex={moduleBridgeHex}
              values={startGenerateReport}
              onFinish={onFinishOld}
              onError={onError}
            />
          )}
        </>
      )}
    </>
  );
};

export default ModalsGenerateReport;
